function Separator() {
    return (
        <div style={{
            minHeight: 56,
            padding: 12,
            backgroundColor: '#212529',
            textAlign: 'center',
        }}></div >
    );
}

export default Separator;